export default __webpack_public_path__ + "static/media/about_us_three.96438812.png";